const isRentalLineItem = (item) =>
  item?.attributes?.some((attr) => attr.key === 'rental' && attr.value === 'true')

const getProductAnalog = (item) =>
  item?.attributes?.find((attr) => attr.key === 'product_analog')?.value?.trim() || null

/**
 * Builds cart/order note from purchase handles of rental line items that have product_analog.
 * e.g. "dji-inspire-3-drone, dji-mavic-3-pro"
 */
export default function getRentalProductAnalogsNote(cartItems) {
  if (!Array.isArray(cartItems) || !cartItems.length) {
    return ''
  }

  const analogs = cartItems
    .filter(isRentalLineItem)
    .map(getProductAnalog)
    .filter(Boolean)

  return [...new Set(analogs)].join(', ')
}
